import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { CollectionDetail } from 'api'
import { RouteConfig } from 'view/routes'
import { LeftNavigationCollections } from 'view/shared/leftNavigation'
import { GridId } from 'store/grid'
import { createSelectedCollectionIdSelector } from 'selectors/selectionSelectors'
import { initiatedNegotiationsCollectionDetailsSelector } from 'selectors/negotiations'
import * as constants from 'view/styles/constants'

interface InitiatedNegotiationsLeftNavigationProps {
  routeConfig: RouteConfig
  collectionDetails: CollectionDetail[]
  selectedCollectionId: string | null
}

const mapStateToProps = createStructuredSelector({
  collectionDetails: initiatedNegotiationsCollectionDetailsSelector,
  selectedCollectionId: createSelectedCollectionIdSelector(GridId.InitiatedGrid)
})

const mapDispatchToProps = {}

const InitiatedNegotiationsLeftNavigationComponent: React.FunctionComponent<InitiatedNegotiationsLeftNavigationProps> = props => {
  const { routeConfig, collectionDetails, selectedCollectionId } = props

  return (
    <LeftNavigationCollections
      gridId={GridId.InitiatedGrid}
      routeConfig={routeConfig}
      collectionDetails={collectionDetails}
      selectedCollectionId={selectedCollectionId}
      collectionColors={[constants.STATUS_COLOR_DEFAULT, constants.STATUS_COLOR_RESPOND, constants.STATUS_COLOR_ACTIVE]}
      showCountdownTimer={true}
    />
  )
}

export const InitiatedNegotiationsLeftNavigation = connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiatedNegotiationsLeftNavigationComponent)
